
import { reactive, computed, watch } from 'vue'
export default {
  components: {
  },
  props: {
    colors: {
      type: String,
      default: 'main',  // main
    },
    type: {
      type: String,
      default: 'full',  // full, border, both
    },
    disable: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: ''
    },
    wd: {
      type: String,
      default: 'md', // md: 180px, sm , auto, smd: 160px, full
    },
    h: {
      type: String,
      default: 'md', // md: 36 , sm: 28
    },
    theme: {
      type: String,
      default: '1', //1: radius, 2: rect, 3: a little radius
    },
    icon: {
      type: String,
      default: '',
    },
    custom: {
      type: String,
      default: '',
    },
    forVal: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    }
  },
  data() {
    return {

    }
  },
  setup(props, { emit }) {
    // const { colors, type, disable, wd, theme, icon, h } = props;
    const { wd, h, icon } = props;

    const state = reactive({
      disable: props.disable,

    })
    // methods
    const onClick = () => {
      if (!state.disable) {
        emit('onClick');
      }

    }

    // computed
    let styleClass = computed(() => [
      `color--${props.colors}`,
      `type--${props.type}`,
      { 'disabled': props.disable },
      { 'style--has-icon': props.icon },
      `theme--${props.theme}`,

    ])
    const styleAll = computed(() => [
      `wd--${wd}`,
      `h--${h}`,

    ])


    watch(
      () => (props),
      (val) => {
        state.disable = val.disable;
      },
      { deep: true },
    )

    const iconSrc = computed(() => {
      if (icon === '') return '';
      return icon.indexOf('http') > -1 ? icon : require(`@/assets/images/${icon}`)
    })

    return {
      state,
      styleClass,
      styleAll,
      iconSrc,
      onClick
    }

  }// end: setup
}


